import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = ({ language }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const whatsappNumber = '5255545675678';
  
  const messages = {
    en: {
      greeting: "Hi! I'm interested in Hexaparks industrial park. Can you help me?",
      title: "Chat with us",
      subtitle: "We typically reply within minutes",
      cta: "Start Chat",
      phone: "Or call us"
    },
    es: {
      greeting: "¡Hola! Me interesa el parque industrial Hexaparks. ¿Pueden ayudarme?",
      title: "Chatea con nosotros",
      subtitle: "Normalmente respondemos en minutos",
      cta: "Iniciar Chat",
      phone: "O llámanos"
    },
    zh: {
      greeting: "您好！我对Hexaparks工业园区感兴趣。您能帮我吗？",
      title: "与我们聊天",
      subtitle: "我们通常在几分钟内回复",
      cta: "开始聊天",
      phone: "或致电我们"
    }
  };
  
  const t = messages[language] || messages.en;
  
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(t.greeting);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Chat popup */}
        {isOpen && (
          <div className="absolute bottom-16 right-0 w-72 bg-white rounded-lg shadow-2xl border border-gray-200 overflow-hidden mb-2 animate-in fade-in slide-in-from-bottom-4 duration-300">
            {/* Header */}
            <div className="bg-[#25D366] p-4 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <MessageCircle className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Hexaparks</p>
                    <p className="text-xs text-white/80">{t.subtitle}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setIsOpen(false)}
                  className="text-white/80 hover:text-white"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            
            {/* Body */}
            <div className="p-4">
              <div className="bg-gray-100 rounded-lg p-3 mb-4">
                <p className="text-sm text-gray-700">{t.title}</p>
              </div>
              
              <button
                onClick={handleWhatsAppClick}
                className="w-full bg-[#25D366] text-white py-3 rounded-lg font-medium text-sm hover:bg-[#20BD5A] transition-colors flex items-center justify-center gap-2"
              >
                <MessageCircle className="w-4 h-4" />
                {t.cta}
              </button>
              
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-xs text-gray-500 mb-2">{t.phone}:</p>
                <div className="space-y-1 text-sm">
                  <a href="tel:+12146953558" className="block text-gray-700 hover:text-gray-900">
                    🇺🇸 +1 (214) 695-3558
                  </a>
                  <a href="tel:+5554567678" className="block text-gray-700 hover:text-gray-900">
                    🇲🇽 +52 55 5456 7678
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* Main button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-14 h-14 bg-[#25D366] rounded-full shadow-lg flex items-center justify-center hover:bg-[#20BD5A] transition-all hover:scale-110"
          aria-label="Chat on WhatsApp"
        >
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <MessageCircle className="w-6 h-6 text-white" />
          )}
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
